import React from "react";
import { Container } from "@mui/material";
import { WhoAreWeSection } from "./styles";
import StandsOut from "../../assets/imgs/stand_out.svg";
import PageIntro from "../../Components/PageIntro";
import PageConversion from "../../Components/PageConversion";
import Reveal from "../../Components/Reveal";

const AboutUs = () => {
	return (
		<WhoAreWeSection>
			<Container>
				<PageIntro title={"Who Are We!"}>
					<strong>VitesLink</strong> is a cutting-edge platform that provides digital invitation solutions for every
					occasion, from weddings, engagements, birthdays, to corporate events, and more.
				</PageIntro>
				<div className={"who_are_we_wrapper"}>
					<Reveal>
						<p className={"mission"}>
							Our mission is to make event invitations seamless, modern, and eco-friendly compared to the traditional
							paper invitations. With VitesLink, you can customize and share your invitation in just a few clicks. No
							paper. No hassle.
						</p>
						<p className={"closing"}>
							Viteslink helps you create and share personalized online invitations with ease — modern, elegant, and
							fully digital.
						</p>
					</Reveal>
					<Reveal direction={"right"} delay={120}>
						<div className={"illustration"}>
							<img src={StandsOut} alt="Stands out" />
						</div>
					</Reveal>
				</div>
			</Container>
			<PageConversion />
		</WhoAreWeSection>
	);
};

export default AboutUs;
